import React, { Component } from 'react';

import { Link } from 'react-router-dom';

import {
	Card,
	CardContent,
	CircularProgress,
	Divider,
	Tabs,
	Tab
} from 'material-ui';

import { Primary, Title } from '../../helper/consts';

import _ from 'lodash';
import moment from 'moment';

import Head from '../../components/Head';
import LoggedOutCard from '../../components/LoggedOutCard';
import SkeletonCard from '../../components/SkeletonCard';
import SkeletonSectionTitle from '../../components/SkeletonSectionTitle';
import DashboardMonthActivityAreaChart from '../../components/DashboardMonthActivityAreaChart';
import DashboardUserActivityLineChart from '../../components/DashboardUserActivityLineChart';
import DashboardApplications from '../../components/DashboardApplications';
import SectionTitle from '../../components/SectionTitle';
import ApplicantCardHeader from '../../components/ApplicantCardHeader';
import UnauthorizedText from '../../components/UnauthorizedText';

const style = {
	loading: {
		alignSelf: 'center',
		width: '75px',
		height: '75px',
		marginTop: 'calc(50vh - 37.5px - 64px)'
	},
	dashboardChartsContainer: {
		width: '100%',
		maxWidth: '1080px',
		display: 'flex',
		flexWrap: 'wrap'
	},
	dashboardChartsCard: {
		flexGrow: '1',
		width: '50%',
		maxWidth: '540px',
		padding: '10px',
		minWidth: '300px',
		margin: '11px 0',
		overflow: 'visible',
		border: '1px solid rgba(0,0,0,0.07)',
		boxShadow: '0 1px 5px rgba(0,0,0,0.05)',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		flexDirection: 'column'
	},
	titleLink: {
		textDecoration: 'underline',
		color: Primary
	},
	dashboardLatestActivityContainer: {
		flexGrow: '1',
		width: '100%',
		maxWidth: '1080px',
		padding: '10px',
		minWidth: '300px',
		margin: '0px 0',
		overflow: 'visible',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		flexDirection: 'column'
	}
};

export default class Dashboard extends Component {
	constructor() {
		super();

		this.state = {
			archives: false
		};
	}

	componentDidMount() {
		let references = [
			{
				uid: '',
				stateName: 'favorites',
				dbName: 'favorites',
				dispatchName: 'JobsState/GET_FAVORITES',
				getJobs: false
			},
			{
				uid: '',
				stateName: 'subscriptions',
				dbName: 'subscriptions',
				dispatchName: 'JobsState/GET_SUBSCRIPTIONS',
				getJobs: false
			},
			{
				uid: '',
				stateName: 'myApplications',
				dbName: 'myApplications',
				dispatchName: 'JobsState/GET_MYAPPLICATIONS',
				getJobs: false
			},
			{
				uid: '',
				stateName: 'invited',
				dbName: 'invited',
				dispatchName: 'JobsState/GET_INVITED',
				getJobs: false
			},
			{
				uid: '',
				stateName: 'commissions',
				dbName: 'myCommissions',
				dispatchName: 'JobsState/GET_COMMISSIONS',
				getJobs: false
			},
			{
				uid: '',
				stateName: 'referred',
				dbName: 'referred',
				dispatchName: 'JobsState/GET_REFERRED',
				getJobs: false
			},
			{
				uid: '',
				stateName: 'myInvites',
				dbName: 'myInvites',
				dispatchName: 'JobsState/GET_MYINVITES',
				getJobs: false
			}
		];
		this.props.actions.getReferences(references);
	}

	renderAreaCharts = () => {
		const {
			favorites,
			invited,
			myApplications,
			commissions,
			myInvites,
			referred
		} = this.props;
		let html = [];
		const data = this.prepData();
		let charts = (
			<div
				key="area_charts"
				style={style.dashboardChartsContainer}
				className="dashboardChartsContainer"
			>
				<Card style={style.dashboardChartsCard} className="dashboardChartsCard">
					<Link style={style.titleLink} to={`/Favorites`}>
						Favorites {`(${_.size(favorites)})`}
					</Link>
					<DashboardMonthActivityAreaChart
						key="favorites_month_activity"
						title={'Favorites'}
						data={_.size(favorites) !== 0 && data}
					/>
				</Card>
				<Card style={style.dashboardChartsCard} className="dashboardChartsCard">
					<Link style={style.titleLink} to={`/Invites`}>
						Invited {`(${_.size(invited)})`}
					</Link>
					<DashboardMonthActivityAreaChart
						key="invited_month_activity"
						title={'Invited'}
						data={_.size(invited) !== 0 && data}
					/>
				</Card>
				<Card style={style.dashboardChartsCard} className="dashboardChartsCard">
					<Link style={style.titleLink} to={`/Applications`}>
						Applications {`(${_.size(myApplications)})`}
					</Link>
					<DashboardMonthActivityAreaChart
						key="applications_month_activity"
						title={'Applications'}
						data={_.size(myApplications) !== 0 && data}
					/>
				</Card>
				<Card style={style.dashboardChartsCard} className="dashboardChartsCard">
					<Link style={style.titleLink} to={`/Commissions`}>
						Commissions {`(${_.size(commissions)})`}
					</Link>
					<DashboardMonthActivityAreaChart
						key="commissions_month_activity"
						title={'Commissions'}
						data={_.size(commissions) !== 0 && data}
					/>
				</Card>
				<Card style={style.dashboardChartsCard} className="dashboardChartsCard">
					Invites{' '}
					{`(${Object.keys(myInvites)
						.map(oid => myInvites[oid])
						.reduce((sum, invite) => (sum += _.size(invite)), 0)})`}
					<DashboardMonthActivityAreaChart
						key="invites_month_activity"
						title={'Invite'}
						data={_.size(myInvites) !== 0 && data}
					/>
				</Card>
				<Card style={style.dashboardChartsCard} className="dashboardChartsCard">
					Referrals {`(${_.size(referred)})`}
					<DashboardMonthActivityAreaChart
						key="referred_month_activity"
						title={'Referrals'}
						data={_.size(referred) !== 0 && data}
					/>
				</Card>
			</div>
		);
		html.push(charts);
		return html;
	};

	renderRecentActivityChart = () => {
		const {
			favorites,
			invited,
			myApplications,
			commissions,
			user
		} = this.props;
		let html = [];
		const data = this.prepData();
		let charts = (
			<Card key="dashboard_recent_activity_card" className="dashboardCard card">
				<ApplicantCardHeader applicant={user} />
				<Divider light />
				<CardContent
					style={style.dashboardLatestActivityContainer}
					className="dashboardChartsCard"
				>
					<DashboardUserActivityLineChart
						key="latest_activity"
						title={'Favorites'}
						data={
							(_.size(favorites) !== 0 ||
								_.size(invited) !== 0 ||
								_.size(commissions) !== 0 ||
								_.size(myApplications) !== 0) &&
							data
						}
					/>
				</CardContent>
			</Card>
		);
		html.push(charts);
		return html;
	};

	prepData = () => {
		const {
			favorites,
			invited,
			myApplications,
			commissions,
			myInvites,
			referred
		} = this.props;
		const monthAgo = moment()
			.add(1, 'days')
			.subtract(4, 'weeks')
			.valueOf();
		let data = [];
		for (let i = 1; i < 31; i++) {
			data.push(i);
		}
		const filteredFavorites = Object.keys(favorites)
			.map(oid => favorites[oid])
			.filter(fav => !!fav.archived === !!this.state.archives);
		const filteredInvited = Object.keys(invited)
			.map(oid => invited[oid])
			.filter(invite => !!invite.archived === !!this.state.archives);
		const filteredMyApplications = Object.keys(myApplications)
			.map(jid => myApplications[jid])
			.filter(app => !!app.archived === !!this.state.archives);
		const filteredCommissions = Object.keys(commissions)
			.map(jid => commissions[jid])
			.filter(commission => !!commission.archived === !!this.state.archives);
		const periods = data.map(day =>
			moment()
				.subtract(day, 'days')
				.valueOf()
		);
		const formatted = periods.map((period, i) => {
			return {
				name: moment(period).format('MMM DD'),
				Invite:
					Object.keys(myInvites).length > 0
						? Object.keys(myInvites)
								.map(oid => myInvites[oid])
								.map(offer =>
									Object.keys(offer)
										.filter(oid => offer[oid].timestamp > monthAgo)
										.map(oid => offer[oid])
								)
								.reduce((a, b) => a.concat(b))
								.filter(invite => {
									return (
										invite.emailSentTimestamp < period &&
										invite.emailSentTimestamp > periods[i + 1]
									);
								}).length
						: 0,
				Favorites:
					filteredFavorites.length > 0
						? filteredFavorites.filter(favorite => {
								return (
									favorite.timestamp < period &&
									favorite.timestamp > periods[i + 1]
								);
						  }).length
						: 0,
				Invited:
					filteredInvited.length > 0
						? filteredInvited.filter(invite => {
								return (
									invite.timestamp < period && invite.timestamp > periods[i + 1]
								);
						  }).length
						: 0,
				Applications:
					filteredMyApplications.length > 0
						? filteredMyApplications.filter(application => {
								return (
									application.timestamp < period &&
									application.timestamp > periods[i + 1]
								);
						  }).length
						: 0,
				Commissions:
					filteredCommissions.length > 0
						? filteredCommissions.filter(commission => {
								return (
									commission.timestamp < period &&
									commission.timestamp > periods[i + 1]
								);
						  }).length
						: 0,
				Referrals:
					Object.keys(referred).length > 0
						? Object.keys(referred).filter(oid => {
								return (
									referred[oid].timestamp < period &&
									referred[oid].timestamp > periods[i + 1]
								);
						  }).length
						: 0
			};
		});
		return formatted.reverse();
	};

	handleTabChange = (e, value) => this.setState({ tab: value });

	renderTabs = () => {
		let html = [];
		let tabs = (
			<Tabs
				value={this.state.tab || 0}
				onChange={this.handleTabChange}
				indicatorColor="primary"
				textColor="primary"
				centered
				style={{ margin: '0 auto' }}
				key="jobs_tabs"
			>
				<Tab
					onClick={() => {
						this.setState({ archives: false });
					}}
					label="Active"
				/>
				<Tab
					onClick={() => {
						this.setState({ archives: true });
					}}
					label="Archived"
				/>
			</Tabs>
		);
		html.push(tabs);
		return html;
	};

	render() {
		return (
			<React.Fragment>
				<Head title={`Dashboard | ${Title}`} />
				<div id={this.props.loggedIn ? 'loggedInBody' : null} className="body">
					{this.props.authLoading && (
						<CircularProgress style={style.loading} size={75} />
					)}
					<div className="dashboardContainer">
						{this.props.loggedIn &&
							!this.props.adminLoading &&
							!this.props.admin &&
							(this.props.referredLoading ||
								this.props.myInvitesLoading ||
								this.props.favoritesLoading ||
								this.props.invitedLoading ||
								this.props.myApplicationsLoading ||
								this.props.commissionsLoading ||
								this.props.subscriptionsLoading) && <SkeletonSectionTitle />}
						{this.props.loggedIn &&
							!this.props.adminLoading &&
							!this.props.admin &&
							!this.props.referredLoading &&
							!this.props.myInvitesLoading &&
							!this.props.favoritesLoading &&
							!this.props.invitedLoading &&
							!this.props.myApplicationsLoading &&
							!this.props.commissionsLoading &&
							!this.props.subscriptionsLoading &&
							this.renderTabs()}

						{this.props.loggedIn &&
							!this.props.adminLoading &&
							!this.props.admin &&
							(this.props.referredLoading ||
								this.props.myInvitesLoading ||
								this.props.favoritesLoading ||
								this.props.invitedLoading ||
								this.props.myApplicationsLoading ||
								this.props.commissionsLoading ||
								this.props.subscriptionsLoading) && <SkeletonSectionTitle />}
						{this.props.loggedIn &&
							!this.props.adminLoading &&
							!this.props.admin &&
							!this.props.referredLoading &&
							!this.props.myInvitesLoading &&
							!this.props.favoritesLoading &&
							!this.props.invitedLoading &&
							!this.props.myApplicationsLoading &&
							!this.props.commissionsLoading &&
							!this.props.subscriptionsLoading && (
								<SectionTitle
									key="latest_activity_area"
									title="Activity Summary"
								/>
							)}
						{this.props.loggedIn &&
							!this.props.adminLoading &&
							!this.props.admin &&
							(this.props.referredLoading ||
								this.props.myInvitesLoading ||
								this.props.favoritesLoading ||
								this.props.invitedLoading ||
								this.props.myApplicationsLoading ||
								this.props.commissionsLoading ||
								this.props.subscriptionsLoading) && (
								<SkeletonCard media={true} header={true} content={true} />
							)}
						{this.props.loggedIn &&
							!this.props.adminLoading &&
							!this.props.admin &&
							!this.props.referredLoading &&
							!this.props.myInvitesLoading &&
							!this.props.favoritesLoading &&
							!this.props.invitedLoading &&
							!this.props.myApplicationsLoading &&
							!this.props.commissionsLoading &&
							!this.props.subscriptionsLoading &&
							this.renderRecentActivityChart()}

						{this.props.loggedIn &&
							!this.props.adminLoading &&
							!this.props.admin &&
							this.props.myApplicationsLoading && <SkeletonSectionTitle />}
						{this.props.loggedIn &&
							!this.props.adminLoading &&
							!this.props.admin &&
							!this.props.myApplicationsLoading && (
								<SectionTitle title="Applications" />
							)}
						{this.props.loggedIn &&
							!this.props.adminLoading &&
							!this.props.admin &&
							this.props.myApplicationsLoading && (
								<SkeletonCard content={true} />
							)}
						{this.props.loggedIn &&
							!this.props.adminLoading &&
							!this.props.admin &&
							!this.props.myApplicationsLoading && (
								<DashboardApplications
									archives={this.state.archives}
									applications={this.props.myApplications}
								/>
							)}

						{this.props.loggedIn &&
							!this.props.adminLoading &&
							!this.props.admin &&
							(this.props.referredLoading ||
								this.props.myInvitesLoading ||
								this.props.favoritesLoading ||
								this.props.invitedLoading ||
								this.props.myApplicationsLoading ||
								this.props.commissionsLoading ||
								this.props.subscriptionsLoading) && <SkeletonSectionTitle />}
						{this.props.loggedIn &&
							!this.props.adminLoading &&
							!this.props.admin &&
							!this.props.referredLoading &&
							!this.props.myInvitesLoading &&
							!this.props.favoritesLoading &&
							!this.props.invitedLoading &&
							!this.props.myApplicationsLoading &&
							!this.props.commissionsLoading &&
							!this.props.subscriptionsLoading && (
								<SectionTitle key="latest_activity" title="Breakdown" />
							)}
						{this.props.loggedIn &&
							!this.props.adminLoading &&
							!this.props.admin &&
							(this.props.referredLoading ||
								this.props.myInvitesLoading ||
								this.props.favoritesLoading ||
								this.props.invitedLoading ||
								this.props.myApplicationsLoading ||
								this.props.commissionsLoading ||
								this.props.subscriptionsLoading) && (
								<SkeletonCard media={true} header={true} content={true} />
							)}
						{this.props.loggedIn &&
							!this.props.adminLoading &&
							!this.props.admin &&
							!this.props.referredLoading &&
							!this.props.myInvitesLoading &&
							!this.props.favoritesLoading &&
							!this.props.invitedLoading &&
							!this.props.myApplicationsLoading &&
							!this.props.commissionsLoading &&
							!this.props.subscriptionsLoading &&
							this.renderAreaCharts()}
					</div>

					{!this.props.authLoading && !this.props.loggedIn && <LoggedOutCard />}

					{!this.props.authLoading &&
						this.props.loggedIn &&
						!this.props.adminLoading &&
						this.props.admin && (
							<div className="unauthorizedTextContainer">
								<UnauthorizedText
									text="Unauthorized"
									subText="Access is limited"
								/>
							</div>
						)}
				</div>
			</React.Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/pages/Dashboard/Dashboard.js